import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const renderTextField = ({
  label = null,
  input,
  placeholder,
  meta: { touched, error, warning },
  readOnly = false,
  required = false,
  maxChars
}) => {
  let classes = ['form-field-text', 'padding-xsm-left'];
  let charCountClasses = ['form-field-text-character-counter'];
  readOnly && classes.push('disabled-text-field');
  touched && error && classes.push('form-field-text-error-state');
  return (
    <Fragment>
      {label && <div className='form-field-label-row'>
        <label>{label} {required && <span className='form-field-required'>*</span>}</label>
      </div>}
      <div className='form-field-text-container'>
        {
          maxChars && (<div className={charCountClasses.join(' ')}>
            {maxChars - input.value.length}
          </div>)
        }
        <input
          style={
            {
              paddingRight: maxChars ? '2rem' : null
            }
          }
          className={classes.join(' ')}
          {...input}
          maxLength={maxChars || 9999}
          disabled={readOnly}
          placeholder={placeholder} />
        {touched &&
          ((error && <div className='form-field-error'>{error}</div>) ||
            (warning && <div className='form-field-error'>{warning}</div>))}
      </div>
    </Fragment>
  );
};

export default renderTextField;

renderTextField.propTypes = {
  input: PropTypes.any,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  meta: PropTypes.any,
  label: PropTypes.string,
  addNew: PropTypes.string,
  readOnly: PropTypes.bool,
  maxChars: PropTypes.number
};
